import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ZoomIn } from 'lucide-react';

// Placeholder images for the gallery - easily replaceable
const GALLERY_IMAGES = [
  { id: 1, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770327680/WhatsApp_Image_2026-02-06_at_03.08.20_vwixc4.jpg', alt: '', category: 'ambience' },
  { id: 2, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370206/WhatsApp_Image_2026-02-06_at_14.57.27_fuagcj.jpg', alt: '', category: 'beverages' },
  { id: 3, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770329094/WhatsApp_Image_2026-02-06_at_03.33.35_1_d8z4wr.jpg', alt: '', category: 'food' },
  { id: 4, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370204/WhatsApp_Image_2026-02-06_at_14.57.28_1_xos3qs.jpg', alt: '', category: 'beverages' },
  { id: 5, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770327679/WhatsApp_Image_2026-02-06_at_03.08.21_rhedzd.jpg', alt: '', category: 'ambience' },
  { id: 6, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770329094/WhatsApp_Image_2026-02-06_at_03.33.34_1_jey1vi.jpg', alt: '', category: 'food' },
  { id: 7, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370206/WhatsApp_Image_2026-02-06_at_14.57.28_plgp4t.jpg', alt: '', category: 'beverages' },
  { id: 8, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770327679/WhatsApp_Image_2026-02-06_at_03.08.47_mglsui.jpg', alt: '', category: 'ambience' },
  { id: 9, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770329094/WhatsApp_Image_2026-02-06_at_03.33.34_yheira.jpg', alt: '', category: 'food' },
  { id: 10, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370205/WhatsApp_Image_2026-02-06_at_14.57.28_2_svz1gl.jpg', alt: '', category: 'beverages' },
  { id: 11, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770327680/WhatsApp_Image_2026-02-06_at_03.07.46_jyh7hd.jpg', alt: '', category: 'ambience' },
  { id: 12, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770329094/WhatsApp_Image_2026-02-06_at_03.33.35_jg8hgc.jpg', alt: '', category: 'food' },
  { id: 13, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370205/WhatsApp_Image_2026-02-06_at_14.57.27_1_krjez9.jpg', alt: '', category: 'beverages' },
  { id: 14, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770327680/WhatsApp_Image_2026-02-06_at_03.08.45_zqngbi.jpg', alt: '', category: 'ambience' },
  { id: 15, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770329095/WhatsApp_Image_2026-02-06_at_03.33.33_fssvnq.jpg', alt: '', category: 'food' },
  { id: 16, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370205/WhatsApp_Image_2026-02-06_at_14.57.29_2_s9fbiz.jpg', alt: '', category: 'beverages' },
  { id: 17, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770327679/WhatsApp_Image_2026-02-06_at_03.08.46_1_fa1nse.jpg', alt: '', category: 'ambience' },
  { id: 18, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770329095/WhatsApp_Image_2026-02-06_at_03.33.33_1_nte3om.jpg', alt: '', category: 'food' },
  { id: 19, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370204/WhatsApp_Image_2026-02-06_at_14.57.29_1_cuxqe7.jpg', alt: '', category: 'beverages' },
  { id: 20, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770327679/WhatsApp_Image_2026-02-06_at_03.08.46_okhwe3.jpg', alt: '', category: 'ambience' },
  { id: 21, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770329095/WhatsApp_Image_2026-02-06_at_03.33.33_2_uxej1q.jpg', alt: '', category: 'food' },
  { id: 22, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370204/WhatsApp_Image_2026-02-06_at_14.57.29_p5u17e.jpg', alt: '', category: 'beverages' },
  { id: 23, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770327679/WhatsApp_Image_2026-02-06_at_03.09.48_pv1fcq.jpg', alt: '', category: 'ambience' },
  { id: 24, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770329095/WhatsApp_Image_2026-02-06_at_03.33.33_3_trnfln.jpg', alt: '', category: 'food' },
  { id: 25, src: 'https://res.cloudinary.com/dql6llktr/image/upload/v1770370204/WhatsApp_Image_2026-02-06_at_14.57.29_3_e63eaw.jpg', alt: '', category: 'beverages' },
];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'ambience', label: 'Ambience' },
    { id: 'food', label: 'Food' },
    { id: 'beverages', label: 'Beverages' },
  ];

  const filteredImages = filter === 'all' 
    ? GALLERY_IMAGES 
    : GALLERY_IMAGES.filter(img => img.category === filter);

  return (
    <div className="page-wrapper pt-24" data-testid="gallery-page">
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 px-6 md:px-12 bg-[#F0EBE0]" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto text-center">
          <motion.span
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-accent text-2xl text-[#E07A5F] block mb-2"
          >
            Take a Look
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-6xl font-black text-[#4A3B32] mb-4"
            style={{ fontFamily: 'Fraunces, serif' }}
          >
            Our Gallery
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-lg text-[#6D5D53] max-w-xl mx-auto"
          >
            Moments captured at A1 Cafe - our food, drinks, and the cozy ambience
          </motion.p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="sticky top-20 z-30 bg-[#F9F7F2] border-b border-[#E6DCC8] py-4 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex justify-center gap-3 flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setFilter(cat.id)}
              data-testid={`gallery-filter-${cat.id}`}
              className={`px-5 py-2 rounded-full font-medium transition-all duration-200 ${
                filter === cat.id
                  ? 'bg-[#4A3B32] text-white'
                  : 'bg-white text-[#4A3B32] hover:bg-[#F0EBE0] border border-[#E6DCC8]'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 md:py-20 px-6 md:px-12 bg-[#F9F7F2]" data-testid="gallery-grid">
        <div className="max-w-7xl mx-auto">
          <motion.div
            layout
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4"
          >
            <AnimatePresence mode="popLayout">
              {filteredImages.map((image, index) => (
                <motion.div
                  key={image.id}
                  layout
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  transition={{ duration: 0.3, delay: index * 0.02 }}
                  className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer shadow-sm hover:shadow-lg transition-shadow duration-300"
                  onClick={() => setSelectedImage(image)}
                  data-testid={`gallery-image-${image.id}`}
                >
                  <img
  src={image.src}
  alt={image.alt}
  className="max-h-[90vh] w-auto object-contain transition-transform duration-500"
  loading="lazy"
/>
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                    <ZoomIn className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
            data-testid="gallery-lightbox"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: 'spring', damping: 25, stiffness: 300 }}
              className="relative w-auto max-h-[90vh] flex items-center justify-center"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-full object-contain rounded-lg"
              />
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute -top-12 right-0 md:top-4 md:right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-colors"
                data-testid="lightbox-close"
              >
                <X className="w-6 h-6" />
              </button>
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/60 to-transparent rounded-b-lg">
                <p className="text-white font-medium text-center">{selectedImage.alt}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* CTA Section */}
      <section className="py-16 px-6 md:px-12 bg-[#4A3B32]" data-testid="gallery-cta">
        <div className="max-w-4xl mx-auto text-center">
          <h2 
            className="text-3xl md:text-4xl font-bold text-white mb-4"
            style={{ fontFamily: 'Fraunces, serif' }}
          >
            Come Create Your Own Memories!
          </h2>
          <p className="text-white/80 mb-8 text-lg">
            Visit us and experience the A1 Cafe vibe in person
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://maps.app.goo.gl/jgFwpAgEZtdiEADL6"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#E07A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#d06a4f] transition-colors"
              data-testid="gallery-directions-btn"
            >
              Get Directions
            </a>
            <a
              href="https://www.instagram.com/a1cafenitk?igsh=MTU5Yno1ZGgxb3BjMQ=="
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#4A3B32] transition-colors"
              data-testid="gallery-instagram-btn"
            >
              Follow on Instagram
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
